// @ts-nocheck
import React from 'react';
import ChangePasswordSection from '../../shared/ChangePasswordSection';
import { ClientPageLede } from '../components/WorkflowFormPrimitives';

export default function SettingsPage() {
  return (
    <div className="space-y-3">
      <ClientPageLede>
        <p>Update your sign-in password. You need your current password to authorize the change.</p>
      </ClientPageLede>
      <ChangePasswordSection />
    </div>
  );
}
